<template>
  <v-expansion-panels
    :value="expansionPanelsModel"
    multiple
    focusable
    class="mt-3"
  >
    <historico-expansion-panel
      titulo="Status"
      :items="historicoStatus"
      :get-items="getHistoricoStatus"
    >
      <timeline-status :items="historicoStatus" />
    </historico-expansion-panel>

    <historico-expansion-panel
      titulo="Responsáveis pelo atendimento"
      :items="historicoAtendentes"
      :get-items="getHistoricoAtendentes"
    />
  </v-expansion-panels>
</template>

<script>
import { ref, watch } from '@vue/composition-api'
import { storeToRefs } from 'pinia'
import HistoricoExpansionPanel from '../historico-tab/HistoricoExpansionPanel.vue'
import TimelineStatus from '../historico-tab/timeline/TimelineStatus.vue'
import useAtendimentoStore from '@/store/atendimento'
import TicketService from '@/services/modules/TicketService'

export default {
  components: {
    HistoricoExpansionPanel,
    TimelineStatus,
  },

  setup() {
    const { ticketSelecionadoId } = storeToRefs(useAtendimentoStore())

    const expansionPanelsModel = ref([])

    const historicoStatus = ref([])
    const historicoAtendentes = ref([])
    const alteracoesHistorico = ref([])

    async function getHistoricoStatus() {
      historicoStatus.value = await TicketService.getTicketHistoricoStatus(ticketSelecionadoId.value)
    }
    async function getHistoricoAtendentes() {
      historicoAtendentes.value = await TicketService.getTicketHistoricoAtendentes(ticketSelecionadoId.value)
    }

    const isGetAlteracoesHistoricoLoading = ref(false)
    async function getAlteracoesHistorico() {
      try {
        isGetAlteracoesHistoricoLoading.value = true
        alteracoesHistorico.value = await TicketService.getTicketHistoricoAlteracoes(ticketSelecionadoId.value)
        isGetAlteracoesHistoricoLoading.value = false
      } catch {
        isGetAlteracoesHistoricoLoading.value = false
      }
    }

    function closeExpansionPanels() {
      expansionPanelsModel.value = []
    }
    async function resetData() {
      if (!ticketSelecionadoId.value) return
      historicoStatus.value = []
      historicoAtendentes.value = []
      alteracoesHistorico.value = []
      closeExpansionPanels()
    }
    watch(() => ticketSelecionadoId.value, resetData, { immediate: true })

    return {
      ticketSelecionadoId,
      expansionPanelsModel,
      historicoStatus,
      getHistoricoStatus,
      historicoAtendentes,
      getHistoricoAtendentes,
      isGetAlteracoesHistoricoLoading,
      alteracoesHistorico,
      getAlteracoesHistorico,
    }
  },
}
</script>
